// extracted by mini-css-extract-plugin
export var container = "InstallModal-module__container___nsTYX";
export var laurels = "InstallModal-module__laurels___wontB";
export var salesPitch = "InstallModal-module__salesPitch___tMGYs";
export var title = "InstallModal-module__title___j9pZ9";